import { Stack, Typography } from '@mui/material';
import { DiagnosticType } from '../../Enum/DiagnosticType';

const BHDiagnosticConfirmationBody: React.FC<{ assessmentName: string; diagnosticType: DiagnosticType }> = ({ assessmentName, diagnosticType }) => {
    return (
        <Stack direction={'column'} alignItems={'center'} spacing={2}>
            <Typography variant="body1" component="label">
                Are you sure you wish to proceed without completing {assessmentName} assessment?
            </Typography>
            {diagnosticType === DiagnosticType.BHDiagnostic && (
                <Typography variant="body1" component="label" color={'error.main'}>
                    Warning! {assessmentName} assessment must be complete if you are performing a BH Diagnostic assessment.
                </Typography>
            )}
        </Stack>
    );
};

export default BHDiagnosticConfirmationBody;
